import styled from '@emotion/styled';
import { theme, media } from '@vfit/shared/themes';

export const GalleryImageContainer = styled.div`
  width: 100%;
  min-height: 553px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;

  ${media.tablet``}

  ${media.desktop``}
`;

export const ThumbnailContainer = styled.div`
  width: 100%;
  height: 100%;
  padding-right: ${theme.spacing.lg};
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: ${theme.spacing.md};
  align-items: center;

  div {
    height: 77px;
    width: 77px;
    cursor: pointer;
  }

  ${media.tablet``}

  ${media.desktop``}
`;

export const SelectedImageContainer = styled.div`
  width: 100%;
  height: 100%;
  padding-right: ${theme.spacing.xl};
  flex: 10;

  ${media.tablet``}

  ${media.desktop``}
`;

export const SwiperContainer = styled.div``;

export const IconContainer = styled.div`
  position: absolute;
  bottom: 80px;
  right: 10px;
  width: 34px;
  height: 34px;
  border: ${theme.borderWidth.thin} solid ${theme.colors.border.default};
  border-radius: 100%;
  z-index: 1;
  text-align: center;
  line-height: 27px;
`;

export interface IArrowButton {
  rotation: number;
  color: string;
  arrowWidth?: number;
  arrowHeigth?: number;
}

export const ArrowButton = styled.div<IArrowButton>`
  margin: 0 auto;
  transform: rotate(${({ rotation }) => `${rotation}deg`});
  display: flex;
  align-items: center;
  justify-content: center;
  border: ${theme.borderWidth.thin} solid ${({ color }) => color};
  border-radius: 100%;
  height: 36px !important;
  width: 36px !important;
  user-select: none;

  svg {
    width: ${({ arrowWidth }) => (arrowWidth ? `${arrowWidth}px` : '9px')};
    height: ${({ arrowHeigth }) => (arrowHeigth ? `${arrowHeigth}px` : '16px')};

    path {
      stroke: ${({ color }) => color};
    }
  }

  &:hover {
    border: ${theme.borderWidth.thin} solid ${theme.colors.text.primary};
    path {
      stroke: ${theme.colors.text.primary};
    }
  }
`;

export const BoxImage = styled.div<{ selected: boolean }>`
  border: ${({ selected }) =>
    selected
      ? `2px solid #0096AD`
      : `${theme.borderWidth.thin} solid ${theme.colors.border.default}`};
  border-radius: 10px;
  overflow: hidden;
`;
